import React, { createContext, useContext, useEffect, useState } from 'react';
import baseURL from './url';

const defaultFeatures = {
    mesas: false,
    codigosDescuento: false,
    gestionTrabajadores: false,
    pedidosWeb: false,
    reportesAvanzados: false,
    estadisticasVisitas: false,
    personalizacionMarca: false,
    bannersProgramables: false,
    qrDinamico: false,
    backupAutomatico: false,
    soportePrioritario: false,
    multiSucursal: false,
    cajaDiaria: false,
    multiCaja: false,
    limites: { productos: 15, banners: 2, categorias: 5, administradores: 1, trabajadores: 0, mesas: 0, codigos: 0, sucursales: 1 },
};

const PlanContext = createContext({
    plan: 'basic',
    features: defaultFeatures,
    vence: null,
    diasRestantes: null,
    activo: true,
    vencido: false,
    mensaje: null,
    isPlus: false,
    loading: true,
    tipoNegocio: 'comidas',
});

export function PlanProvider({ children }) {
    const [plan, setPlan] = useState('basic');
    const [features, setFeatures] = useState(defaultFeatures);
    const [vence, setVence] = useState(null);
    const [diasRestantes, setDiasRestantes] = useState(null);
    const [activo, setActivo] = useState(true);
    const [vencido, setVencido] = useState(false);
    const [mensaje, setMensaje] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tipoNegocio, setTipoNegocio] = useState('comidas');

    useEffect(() => {
        fetch(`${baseURL}/planGet.php`)
            .then(r => r.json())
            .then(data => {
                setPlan(data.plan || 'basic');
                setFeatures({ ...defaultFeatures, ...(data.features || {}) });
                setVence(data.vence || null);
                setDiasRestantes(data.diasRestantes ?? null);
                setActivo(data.activo !== false);
                setVencido(!!data.vencido);
                setMensaje(data.mensaje || null);
                setTipoNegocio(data.tipoNegocio === 'tienda' ? 'tienda' : 'comidas');
            })
            .catch(() => {
                setPlan('basic');
                setFeatures(defaultFeatures);
                setTipoNegocio('comidas');
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <PlanContext.Provider value={{
            plan, features, vence, diasRestantes,
            activo, vencido, mensaje,
            isPlus: plan === 'plus', loading,
            tipoNegocio, esTienda: tipoNegocio === 'tienda',
        }}>
            {children}
        </PlanContext.Provider>
    );
}

export function usePlan() {
    return useContext(PlanContext);
}

export default PlanContext;
